<template>
  <v-edit-dialog
    :return-value.sync="selectedDateTime"
    persistent
    large
    @open="open"
    @save="save"
  >
    <v-layout row justify-center align-center>
      <v-icon>schedule</v-icon>
      <div>{{ formattedDateTime }}</div>
    </v-layout>
    <template v-slot:input>
      <v-date-picker
        :label="column.label"
        v-model="date"
        locale="ru"
        :first-day-of-week="1"
      >
      </v-date-picker>
      <v-time-picker v-model="time" format="24hr" class="ml-12">
      </v-time-picker>
    </template>
  </v-edit-dialog>
</template>

<script>
import moment from "moment-timezone";
import entities from "../../api/entities";

export default {
  name: "DateTimePickerColumn",
  data() {
    return {
      selectedDateTime: null
    };
  },
  computed: {
    date: {
      get() {
        return moment(this.selectedDateTime).format("YYYY-MM-DD");
      },
      set(v) {
        let date = moment(v, "YYYY-MM-DD");
        const hour = this.selectedDateTime
          ? moment(this.selectedDateTime).hour()
          : 0;
        const minute = this.selectedDateTime
          ? moment(this.selectedDateTime).minute()
          : 0;
        date = date.hour(hour).minute(minute);
        console.log("set date", this.selectedDateTime, v, date);
        this.selectedDateTime = date.toDate();
      }
    },
    time: {
      get() {
        return moment(this.selectedDateTime).format("HH:mm");
      },
      set(v) {
        const time = moment(v, "HH:mm");
        console.log(moment(this.selectedDateTime));
        const result = moment(this.selectedDateTime)
          .hour(time.hour())
          .minute(time.minute())
          .second(0);
        console.log("set time", this.selectedDateTime, v, result);
        this.selectedDateTime = result.toDate();
      }
    },
    formattedDateTime() {
      if (!this.value) return "";
      const date = new Date(this.value);
      return moment(date).format("DD.MM.YYYY HH:mm");
    }
  },
  props: ["entity_type", "entity", "column", "value"],
  methods: {
    open() {
      if (this.value) this.selectedDateTime = new Date(this.value);
      else this.selectedDateTime = new Date();
    },

    async save() {
      console.log("DateTimePickerColumn.save");
      // TODO: proper work with timezones
      const data = {};
      data[this.column.name] = moment(this.selectedDateTime).toISOString();
      // .slice(0, -1);
      console.log(data[this.column.name]);
      const result = await entities.update(
        this.token,
        this.entity_type,
        this.entity.id,
        data
      );
      if (result.success) this.value = this.selectedDateTime;
      const color = result.success ? "green" : "red";
      this.$root.$emit("notify", result.message || "Успешно сохранено", color);
    }
  }
};
</script>

<style scoped></style>
